var _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSales3 = function SvgSales3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64.41 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M29.301 23.144 11.14 41.305l-7.464-7.463-3.677 3.677 11.141 11.14L32.978 26.82Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(-1556.184 -677.47)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1605.725 684.9a7.435 7.435 0 1 0 7.434-7.434 7.435 7.435 0 0 0-7.434 7.434m4.192 0a3.242 3.242 0 1 1 3.242 3.242 3.246 3.246 0 0 1-3.242-3.242"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1610.371 695.787)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1610.371 704.813)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1610.371 713.84)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1610.371 722.866)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1610.371 731.892)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1601.205 731.892)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1592.039 731.892)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1582.873 731.892)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1573.707 731.892)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.47 16.441a1.057 1.057 0 0 0 1.468-.291 9.208 9.208 0 0 1 15.286-.019 1.058 1.058 0 1 0 1.756-1.182 11.3 11.3 0 0 0-5.569-4.335 5.981 5.981 0 1 0-7.585-.024 11.3 11.3 0 0 0-5.647 4.383 1.057 1.057 0 0 0 .291 1.468M9.633 2.117a3.864 3.864 0 1 1-3.864 3.864 3.87 3.87 0 0 1 3.864-3.864m4.222 16.627-1.578 1.139a.66.66 0 0 0-.244.743l.636 1.842a.7.7 0 0 1 .033.239.7.7 0 0 1-1.1.505l-1.578-1.139a.675.675 0 0 0-.788 0l-1.578 1.139a.7.7 0 0 1-1.1-.505.7.7 0 0 1 .034-.239l.635-1.842a.66.66 0 0 0-.243-.743l-1.579-1.139a.714.714 0 0 1 .394-1.277H7.75a.61.61 0 0 0 .637-.386l.6-1.854a.671.671 0 0 1 1.274 0l.6 1.854a.61.61 0 0 0 .637.386h1.951a.714.714 0 0 1 .394 1.277Zm-9.051 3.705"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    transform: "translate(-1556.184 -677.47)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1597.141 682.115)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.789,
    cy: 2.789,
    r: 2.789,
    transform: "translate(1587.975 682.115)"
  }))));
};
export default SvgSales3;